import React from "react";

const InvoiceStagingLoadable = React.lazy(() => import("./InvoiceStagingTabs"));

export {
    InvoiceStagingLoadable
};